import React from "react";
import PortfolioContainer from "./components/PortfolioContainer";
import './App.css';


const App = () => <PortfolioContainer />;




export default App;
